module.exports = __webpack_public_path__ + "static/video1-d0fcf0cf5b2042360ad051216047f93b.mp4";